import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Utils } from 'formiojs';

@Pipe({
  name: 'evaluationDisplay',
})
export class EvaluationDisplayPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(resourceItem: any, evaluateString): string {
    if (typeof resourceItem === 'string' || !resourceItem) {
      return resourceItem;
    }
    return Utils.evaluate(evaluateString, {
      item: resourceItem,
      translate: this.translateService,
    });
  }
}
